export default __webpack_public_path__ + "static/media/nv_banner_img1.bd7d5113.png";